import { render, staticRenderFns } from "./TenantCreateEditModal.vue?vue&type=template&id=0054edea"
import script from "./TenantCreateEditModal.vue?vue&type=script&lang=js"
export * from "./TenantCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports